// For new images, upload them to the asset server S3 bucket and match the file path to the string in this file

const imageBasePath = `${process.env.REACT_APP_ASSET_SERVER}/bl-platform/images/`;

enum BaseFolder {
	AddThis = 'addthis-icon.svg',
	AssistantWelcome1 = 'assistant-welcome-1.png',
	BlueLinesLeft = 'blue-lines-left.svg',
	BlueLinesRight = 'blue-lines-right.svg',
	BrandLiveLogo = 'BrandLive_Logo.svg', // This one is styled with CSS, can't remove file
	EventsEmpty = 'events-empty.png',
	FormLeft = 'form-left.svg',
	FormRight = 'form-right.svg',
	GreenroomLogo = 'greenroom-logo.svg',
	HeaderImage = 'header-image.png',
	Hubspot1 = 'hubspot-1.svg',
	IcAnalytics = 'ic_analytics.svg',
	NewAssistnantWelcome51 = 'new-assistant-welcome-5-1.png',
	NowStreamingOnBrandlive = 'now-streaming-on-brandlive.svg', // This one is styled with CSS, can't remove file
	OrangeLinesLeft = 'orange-lines-left.svg',
	Salesforce2 = 'salesforce-2.svg',
	SAMLLogo = 'saml-logo.svg',
	SpaceBackground = 'space-background.png',
	TellyMarch = 'telly-march.svg',
	TellyMegaphone = 'Telly-megaphone.svg',
	TellySpace = 'TellySpace.png',
	Welcome2 = 'welcome-2.png',
	Welcome3 = 'welcome-3.png',
	Welcome4 = 'welcome-4.png'
}

enum IconsReactionsBlFolder {
	heart = 'heart.png',
	shocked = 'shocked.png',
	thumbsUp = 'thumbs-up.png'
}

enum LogosFolder {
	Google = 'Google.svg',
	JiraLogo = 'jira-logo.png',
	Oauth2SM = 'oauth-2-sm.png'
}

enum UiAssetsFolder {
	ChatOverlay = 'chat-overlay.svg',
	ChatSidebar = 'chat-sidebar.svg',
	NavigationNoMenu = 'navigation-no-menu.svg',
	NavigationWithMenu = 'navigation-with-menu.svg',
}

const FilePaths = {
	...BaseFolder,
	...IconsReactionsBlFolder,
	...LogosFolder,
	...UiAssetsFolder
};
export type FilePaths = typeof FilePaths;

const appendBasePath = (folder: Record<string, string>, additionalPath = '') => Object.keys(folder).reduce((acc, cur) => ({
	...acc,
	[cur]: imageBasePath + additionalPath + folder[cur]
}), {});

export default {
	...appendBasePath(BaseFolder),
	...appendBasePath(IconsReactionsBlFolder, 'icons/reactions/bl/'),
	...appendBasePath(LogosFolder, 'logos/'),
	...appendBasePath(UiAssetsFolder, 'ui-assets/'),
} as (typeof FilePaths);